/* Hospital @ Home Command Center constants */
export const RISK_COLORS = {
  stable: "#10B981", moderate: "#F59E0B", high: "#F97316", critical: "#EF4444",
};
export const NEWS2_COLORS = {
  "0-2": "#10B981", "3-4": "#F59E0B", "5-6": "#F97316", "7+": "#EF4444",
};
export const SOURCE_COLORS = {
  rpm: "#8B5CF6", hotline: "#F59E0B", teleconsult: "#0B7E8C",
  home_visit: "#10B981", order: "#3B82F6",
};
